<template>
  <div class="row mx-0 px-3 py-4 border-top">
    <div class="input-group row pe-0">
      <div
        class="d-flex pe-0 justify-content-between justify-content-md-start align-items-center mb-1"
      >
        <label class="size-12" for="">性別</label>
        <span class="tag-thirdly size-10 ms-2">必須</span>
      </div>
      <div class="row p-0">
        <div class="col-4 pe-0">
          <Field v-slot="{ field, errors }" v-model="baseInformationStore.gender" name="gender">
            <div class="form-check bg-grey-05 ps-3 ps-md-4 p-0d8 rounded-3">
              <input
                id="sex-male"
                class="ms-0 form-check-input radio-primary-input w-1d5 h-1d5 me-2"
                type="radio"
                v-bind="field"
                :class="{ 'is-invalid': !!errors.length }"
                :value="1"
                :checked="baseInformationStore.gender == 'male'"
              />
              <label class="form-check-label form-check-label-base pt-1" for="sex-male">男</label>
            </div>
          </Field>
        </div>
        <div class="col-4 pe-0">
          <Field v-slot="{ field, errors }" v-model="baseInformationStore.gender" name="gender">
            <div class="form-check bg-grey-05 ps-3 ps-md-4 p-0d8 rounded-3">
              <input
                id="sex-female"
                class="ms-0 form-check-input radio-primary-input w-1d5 h-1d5 me-2"
                type="radio"
                v-bind="field"
                :class="{ 'is-invalid': !!errors.length }"
                :value="2"
                :checked="baseInformationStore.gender == 'female'"
              />
              <label class="form-check-label form-check-label-base pt-1" for="sex-female">女</label>
            </div>
          </Field>
        </div>
        <div class="col-4 pe-0">
          <Field v-slot="{ field, errors }" v-model="baseInformationStore.gender" name="gender">
            <div class="form-check bg-grey-05 ps-3 ps-md-4 rounded-3 py-0d8">
              <input
                id="sex-other"
                class="ms-0 form-check-input radio-primary-input w-1d5 h-1d5 me-2"
                type="radio"
                v-bind="field"
                :class="{ 'is-invalid': !!errors.length }"
                :value="3"
                :checked="baseInformationStore.gender == 'other'"
              />
              <label class="form-check-label form-check-label-base pt-1" for="sex-other">
                その他
              </label>
            </div>
          </Field>
        </div>
      </div>
    </div>
    <ErrorMessage name="gender" class="d-block invalid-feedback" />
  </div>
</template>

<script setup lang="ts">
import { ErrorMessage, Field } from 'vee-validate';
import { useBaseInformationStore } from '@/stores/resume-candidate/BasicInformation.store';
const baseInformationStore = useBaseInformationStore();
</script>
